<div [formGroup]="parent">
  <div class="col-lg">
    <div class="gray-bg-rounded">
      <ng-container formGroupName="lines">
        <div class="row">
          <div class="col">
            <h3 class="mb-2" *ngIf="!isSummary">Line # 1</h3>
            <h3 class="mb-2" *ngIf="isSummary">Line # {{ lineNumber }}</h3>
          </div>
        </div>
        <div class="row">
          <div class="col mb-2" [hidden]="true">
            <div class="form-group has-float-label">
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                placeholder=""
                formControlName="id" />
            </div>
          </div>
          <div class="col mb-2">
            <div class="form-group has-float-label">
              <label class="form-label"
                >Vendor SKU <span class="madatory-field">*</span></label
              >
              <input
                pInputText
                jniAutoCompleteBlocker
                #vendorSKU
                type="text"
                class="form-control"
                placeholder=""
                formControlName="externalItemNumberD365"
                [ngClass]="{
                  'has-error': formErrors['externalItemNumberD365'],
                }"
                (blur)="logValidationErrors()"
                [maxLength]="20" />

              <span
                class="error-msg"
                *ngIf="formErrors['externalItemNumberD365']">
                {{ formErrors["externalItemNumberD365"] }}
              </span>
            </div>
          </div>
          <div class="col mb-2">
            <div class="form-group has-float-label">
              <label class="form-label"
                >Category <span class="madatory-field">*</span></label
              >
              <p-select
                id="currency"
                formControlName="itemNumberD365"
                [ngClass]="{ 'has-error': formErrors['itemNumberD365'] }"
                (blur)="logValidationErrors()"
                [options]="releasedProductsList"
                optionLabel="itemNumberD365"
                optionValue="itemNumberD365">
              </p-select>

              <span class="error-msg" *ngIf="formErrors['itemNumberD365']">
                {{ formErrors["itemNumberD365"] }}
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col mb-2">
            <div class="form-group has-float-label">
              <label class="form-label"
                >Quantity <span class="madatory-field">*</span></label
              >
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                placeholder=""
                formControlName="orderedPurchaseQuantityD365"
                (focusout)="onQuantityChange($event)"
                [ngClass]="{
                  'has-error': formErrors['orderedPurchaseQuantityD365'],
                }"
                (blur)="logValidationErrors()" />

              <span
                class="error-msg"
                *ngIf="formErrors['orderedPurchaseQuantityD365']">
                {{ formErrors["orderedPurchaseQuantityD365"] }}
              </span>
            </div>
          </div>
          <div class="col align-items-center d-flex gap-3 mb-2">
            <div class="form-group has-float-label">
              <!-- <input pInputText
            jniAutoCompleteBlocker
            [value]="shipDateOne | date: 'yyyy-MM-dd'"
            [min]="shipDateCurrentdate | date: 'yyyy-MM-dd'"
            id="shipdate1"
            name="shipdate1"
            class="form-control"
            (change)="onShipDateOneSelection($event)"
            onfocus="(this.type='date')"
            onblur="if(!this.value) this.type='text'"
          /> -->
              <label class="form-label">Ship date</label>
              <p-datePicker
                jniAutoCompleteBlocker
                inputId="basic"
                class="date-input"
                (onSelect)="onShipDateOneSelection($event)"
                formControlName="requestedShippingDateD365"
                [minDate]="shipDateCurrentdate"
                [showOtherMonths]="true"
                [selectOtherMonths]="true"></p-datePicker>
            </div>
            <div class="form-group has-float-label flex-grow-1">
              <label class="form-label"
                >In-hands date<span class="madatory-field">*</span></label
              >
              <p-datePicker
                jniAutoCompleteBlocker
                inputId="basic"
                class="date-input"
                (onSelect)="onInHandDateOneSelection($event)"
                formControlName="requestedDeliveryDateD365"
                [minDate]="inHandDateCurrentdate"
                [ngClass]="{
                  'has-error': formErrors['requestedDeliveryDateD365'],
                }"
                (onBlur)="logValidationErrors()"
                [showOtherMonths]="true"
                [selectOtherMonths]="true"></p-datePicker>

              <span
                class="error-msg"
                *ngIf="formErrors['requestedDeliveryDateD365']">
                {{ formErrors["requestedDeliveryDateD365"] }}
              </span>
            </div>
            <div class="form-check ms-2 d-flex gap-2 mt-3">
              <p-checkbox
                id="firm1"
                [binary]="true"
                formControlName="rsmFirmD365"
                [(ngModel)]="firmOneCheckBox" />
              <label class="firm mt-2">Firm</label>
            </div>
          </div>

          <!-- <input pInputText
            jniAutoCompleteBlocker
            [value]="inHandDateOne | date: 'yyyy-MM-dd'"
            [min]="inHandDateCurrentdate | date: 'yyyy-MM-dd'"
            id="inhandsdate1"
            name="inhandsdate1"
            class="form-control"
            (change)="onInHandDateOneSelection($event)"
            onfocus="(this.type='date')"
            onblur="if(!this.value) this.type='text'"
          /> -->
          <!-- {{ parent.value | json }} -->
        </div>
        <div class="row hideincollapseflex">
          <div
            class="col mb-2"
            [ngClass]="{ 'has-icon': currencyConversionStatus === true }">
            <div class="form-group has-float-label">
              <label class="form-label">Net</label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control short-width"
                placeholder=""
                formControlName="purchasePriceD365"
                [value]="
                  netValueWithIcon
                    | currency: isoCurrencyCode : 'symbol' : '0.4-4'
                "
                (focusout)="onNetConversion($event)" />
            </div>
          </div>
          <div class="col mb-2">
            <div
              class="form-group has-float-label"
              *ngIf="currencyConversionStatus">
              <label class="form-label"></label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control short-width"
                placeholder=""
                id="netConvertToUsd"
                [value]="netConvertToUsd | currency: 'USD' : 'symbol' : '0.4-4'"
                formControlName="netConversion" />
            </div>
          </div>
          <div
            class="col mb-2"
            [ngClass]="{ 'has-icon': currencyConversionStatus === true }">
            <div class="form-group has-float-label">
              <label class="form-label">Net Total</label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control short-width"
                placeholder=""
                formControlName="lineAmountD365"
                [value]="
                  netTotalPrice | currency: isoCurrencyCode : 'symbol' : '1.2-2'
                " />
            </div>
          </div>
          <div class="col mb-2">
            <div
              class="form-group has-float-label"
              *ngIf="currencyConversionStatus">
              <label class="form-label"></label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control short-width"
                placeholder=""
                formControlName="netConversionTotal"
                [value]="
                  netTotalPriceConverted | currency: 'USD' : 'symbol' : '1.2-2'
                " />
            </div>
          </div>
        </div>
        <div class="row hideincollapseflex">
          <div class="col-12 col-md-6 mb-2">
            <div class="text-end mb-2">
              <div class="d-flex justify-content-between align-items-center">
                <label class="form-label">Description</label>
                <a
                  class="link fontbold text-underline"
                  (click)="showPositionDialogDescription('bottomright')"
                  >Stock Phrase</a
                >
              </div>
            </div>
            <div class="form-group has-float-label">
              <textarea
                pInputText
                jniAutoCompleteBlocker
                placeholder=""
                class="form-control"
                rows="10"
                formControlName="lineDescriptionD365"
                [ngClass]="{ 'has-error': formErrors['lineDescriptionD365'] }"
                (blur)="logValidationErrors()"></textarea>

              <span class="error-msg" *ngIf="formErrors['lineDescriptionD365']">
                {{ formErrors["lineDescriptionD365"] }}
              </span>
            </div>
          </div>
          <div class="col-12 col-md-6 mb-2">
            <div class="text-end mb-2">
              <div class="d-flex justify-content-between align-items-center">
                <label class="form-label">Factory notes</label>
                <a
                  class="link fontbold text-underline"
                  (click)="showPositionDialogFactory('bottom-right')"
                  >Stock Phrase</a
                >
              </div>
            </div>
            <div class="form-group has-float-label">
              <textarea
                rows="10"
                pInputText
                jniAutoCompleteBlocker
                placeholder=""
                class="form-control"
                formControlName="factoryNotesD365"
                [ngClass]="{ 'has-error': formErrors['factoryNotesD365'] }"
                (blur)="logValidationErrors()"></textarea>

              <span class="error-msg" *ngIf="formErrors['factoryNotesD365']">
                {{ formErrors["factoryNotesD365"] }}
              </span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
